module.exports = __webpack_public_path__ + "static/media/009.578570d6.jpg";